import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { componentId: Number }

  connect() {
    const eventsJson = this.element.dataset.events
    const reload = this.element.dataset.reload === 'true'
    
    if (eventsJson && eventsJson !== '[]' && eventsJson !== 'null') {
      try {
        const events = JSON.parse(eventsJson)
        
        if (Array.isArray(events) && events.length > 0) {
          const calendarController = document.querySelector(`[data-controller~="component-lessons-scheduler"][data-component-lessons-scheduler-component-id-value="${this.componentIdValue}"]`)
          
          if (calendarController) {
            calendarController.dispatchEvent(new CustomEvent('component-lessons-scheduler:add-events', {
              detail: { events: events, reload: reload }
            }))
            this.element.dataset.events = '[]'
          } else {
            console.warn('Calendar controller not found for component', this.componentIdValue)
          }
        }
      } catch (error) {
        console.error('Error parsing events JSON:', error)
      }
    }
  }
}
